import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="color-palette-colors"
export default class extends Controller {
    connect() {
        $(document).on('turbo:load cocoon:after-insert', ev => {
            const colorsDropdowns = document.querySelectorAll('.colorSelect')

            if (colorsDropdowns.length) {
                this.setColoredDiv()
                this.updateAvailableColors()
                colorsDropdowns.forEach((d) => {
                    d.addEventListener('change', () => {
                        this.setColoredDiv()
                        this.updateAvailableColors()
                    })
                })
            }
        })

        $(document).on('cocoon:before-remove', (event, item) => {
            const dropdown = item.find('.colorSelect')[0]
            if (dropdown) {
                this.removedColorId = dropdown.value
            }
        })

        $(document).on('cocoon:after-remove', (event, item) => {
           
            this.updateAvailableColors()
            // Clear the stored color ID
            this.removedColorId = null
        })
    }
    setColoredDiv() {
        const colorsDropdowns = document.querySelectorAll('.colorSelect')
        colorsDropdowns.forEach((s) => {
            let div = s.closest('.row').querySelector('.colorDiv')
            let hex_code = s.selectedOptions[0].dataset.hex
            div.style.backgroundColor = hex_code || 'white'
        })
    }

    updateAvailableColors() {
        const colorsDropdowns = document.querySelectorAll('.colorSelect')
        const selectedColorIds = new Set()
        
        colorsDropdowns.forEach((dropdown) => {
            const nestedField = dropdown.closest('.nested-fields')
            const destroyField = nestedField.querySelector('input[name*="[_destroy]"]')
            
            if (destroyField && destroyField.value === '1') {
                return
            }

            const selectedOption = dropdown.selectedOptions[0]
            if (selectedOption && selectedOption.value) {
                selectedColorIds.add(selectedOption.value)
            }
        })

        colorsDropdowns.forEach((dropdown) => {
            const nestedField = dropdown.closest('.nested-fields')
            const destroyField = nestedField.querySelector('input[name*="[_destroy]"]')
            
            if (destroyField && destroyField.value === '1') {
                return
            }

            const currentSelectedId = dropdown.selectedOptions[0]?.value
            
            Array.from(dropdown.options).forEach((option) => {
                if (!option.value) return // Skip the blank option
                
                const isSelected = option.value === currentSelectedId
                const isSelectedElsewhere = !isSelected && selectedColorIds.has(option.value)
                
                if (this.removedColorId === option.value) {
                    option.disabled = false
                    option.style.display = ''
                    return
                }
                
                option.disabled = isSelectedElsewhere
                if (isSelectedElsewhere) {
                    option.style.display = 'none'
                } else {
                    option.style.display = ''
                }
            })
        })
    }
}